export default {
    404: "¡¡Whoops 404!! La página no está disponible",
    admin_RemoveItem: "Eliminar {v1}",
    admin_AddItem: "Añadir {v1}",
    admin_Admin: "Administrador",
    admin_Owner: "Contacto",
    admin_Client: "Usuario",
    admin_Votes: "Votos",
    admin_Profiles: "Perfiles",
    admin_Organizations: "Organizaciones",
    admin_showAllPlaces: "Mostrar todos los lugares",
    admin_SaveRole: "Guardar Funcion",
    admin_deleteRole: "Borrar perfil {v1} {v2}?",
    admin_deleteVote: "¿Borrar el voto de la pregunta \"{v1}\"?",
    admin_deletePlace: "¿Borrar la ubicación \"{v1}\"?",
    admin_deleteOrganization: "¿Borrar la organización \"{v1}\"?",
    admin_deletePlaceWarning: "** Todos los votos relacionados serán eliminados **",
    admin_successMessageAddOwner: "Contacto añadido",
    admin_successMessageAddPlace: "Ubicación añadida",
    admin_successMessageRemoveOwner: "Propietario eliminado",
    admin_successMessageRemovePlace: "Lugar eliminado",
    admin_successMessageRemoveVote: "Voto eliminado",
    admin_successMessageRemoveOrganization: "Organización eliminada",
    admin_successMessageSaveOrganization: "Organización guardada",
    admin_successMessageChangeRole: "Rol cambiado",
    admin_Stickers: "Etiquetas",
    admin_ChangeStatusToCancelled: "¿Cambiar el estado a \"Cancelado\"?",
    admin_ChangeStatusToSent: "¿Cambiar el estado a \"Enviado\"?",
    admin_ChangeStatusToCompleted: "¿Cambiar el estado a \"Completado\"?",
    admin_adminVotesShowAll: "Mostrar todos los votos",
    admin_searchByName: "Buscar por nombre",
    admin_signInAs: "Inicie sesión como: {v1}?",
    admin_ReturnToOriginalAccount: "Volver a la cuenta original: {v1}?",
    admin_closeAccountRequests: "Cerrar solicitudes de cuenta",
    admin_landingQuestions: "Preguntas de aterrizaje",
    admin_firstName: "Nombre",
    admin_lastName: "Apellido",
    admin_contactEmail: "Email de contacto",
    admin_phone: "Telefono",
    admin_success: "Exito",
    admin_userCreated: "Se ha creado un nuevo usuario",
    admin_sortBy: "Ordenar por",
    admin_sortByName: "Nombre",
    admin_sortByAdded: "Añadido",
    admin_sortByUpdated: "Actualizado",
    admin_sortByEmail: "Email",
    admin_sortByCreated: "Creado",
    adminPanel: "Panel de administracion",
    admin_Add: "Añadir",
    admin_Places: "Lugares",
    admin_UnQuestions: "Preguntas no vinculadas",
    admin_ChooseYourPlace: "Seleccione la ubicación de su negocio",
    admin_NothingFound: "No se ha encontrado nada",
    admin_Delete: "Borrar",
    admin_delete_image: "¿Quieres eliminar imágenes?",
    admin_successImageDelete: "La imagen ha sido eliminada",
    Track_vote: "Para hacer un seguimiento de sus votos, inicie sesión:",
    Logout: "Cerrar sesión",
    Sync_status: "Estado de la sincronización",
    Success: "Éxito",
    Error: "Error",
    Back: "Volver a la cuenta original: {v1}?",
    No_votes: "Todavía no tienes ningún voto",
    statusMessage: "Trabajando...",
    Save: "Guardar",
    sign_in_to_connect: "Por favor, inicie sesión para conectar esta pregunta con su negocio",
    yes: "Si",
    no: "No",
    YourVotes: "Tus votos",
    OtherVotes: "Votos de otros usuarios",
    AirVotes: "Airvotes",
    Change: "Cambiar",
    Submit: "Enviar",
    Cancel: "Cancelar",
    CancelRequest: "La solicitud ha sido cancelada",
    ChangedYourMind: "¿Has cambiado de opinión? Seleccione otra votación.  Ten en cuenta que la fecha/hora seguirá siendo la misma.",
    NotConnectedPlaceToAirVote: "Este lugar no está actualmente conectado a AirVote",
    From: "Desde",
    To: "Hasta",
    bflow_BusinesConnectQuestion: "Por favor, elija su negocio para conectar la pregunta \"{v1}",
    bflow_BusinesConnectQuestionSuccess: "La pregunta se ha vinculado con éxito",
    bflow_ChoosePlace: "Por favor, elija un lugar para conectar la pregunta \"{v1}",
    bflow_AddQuestionSuccess: "Pregunta añadida",
    bflow_BecameOwnerPlace: "Hecho. Ahora eres un contacto designado para \"{v1}",
    bflow_BecameOwnerPlaceConfirm: "¿Incluirle en la lista de contactos designados para \"{v1}\" ?",
    bflow_ConfirmConnectQuestionToPlace: "¿Añadir la pregunta \"{v1}\" a esta ubicación \"{v2}\"?",
    bflow_ConfirmConnectQuestionToPlacebelow: "¿Añadir la pregunta \"{v1}\" a la siguiente ubicación ?",
    bflow_ConnectedQuestion: "Conectando la pregunta...",
    bflow_finishBusinesFlow: "¿Quieres salir ?",
    bi_Name: "Nombre",
    bi_OfficialName: "Apellido",
    bi_ContactEmail: "Email de contacto",
    bi_Phone: "Telefono",
    bi_Password: "Codigo secreto",
    bi_Edit: "Editar",
    bi_Address: "Direccion",
    bi_WebsiteUrl: "Url de sitio web",
    bi_validation_OrganizationRequired: "Se requiere el nombre de la organización",
    bi_validation_Email: "Formato del email incorrecto",
    bi_validation_Phone: "Formato de teléfono incorrecto",
    bi_validation_Website: "Formato del sitio web incorrecto",
    bi_first_Name: "Nombre",
    bi_last_Name: "Apellido",
    bi_confirm_email: "Direccion email sin confirmar",
    bi_resend_email: "Reenviar el email de autorización",
    bi_resend_email_success: "El email de confirmación ha sido reenviado con éxito",
    bi_set_password: "Establecer contraseña",
    bi_change_password: "Cambia la contraeña",
    bi_cancel_password: "Cancelar el cambio de contraseña",
    bi_current_password: "Contraseña actual",
    bi_new_password: "Nueva contraseña",
    bi_retype_password: "Volver a introducir la nueva contraseña",
    bi_save_password: "Guardar la nueva contraseña",
    bi_password_change_success: "Cambio de contraseña con éxito",
    own_use_w3w: "Geolocalización -> Utilizar what3words",
    own_email_Confim: "Por favor, confirme su dirección de email",
    own_anyConnectedPlace: "Todavía no hay ningún sitio de negocios conectado",
    own_myQuestions: "Mis preguntas",
    own_createQuestion: "Crear una pregunta",
    own_orderStickers: "Pedir smileys QR",
    own_selectRange: "Seleccione la gama",
    own_today: "Hoy",
    own_last7days: "Últimos 7 días",
    own_lastMonth: "Ultimo mes",
    own_allTime: "Todo el tiempo",
    own_custom: "Personalizado",
    own_Search: "Buscar en",
    own_showMore: "Mostrar mas",
    own_showLess: "Mostrar menos",
    own_Locations: "Colocaciones",
    own_Questions: "Preguntas",
    own_Total: "Total",
    own_Happy: "Feliz",
    own_SoSo: "Más o menos",
    own_Sad: "Triste",
    own_green: "Verde",
    own_yellow: "Amarillo",
    own_red: "Rojo",
    own_EditQuestion: "Editar pregunta",
    own_DownloadPDF: "Generar smileys QR",
    own_DownloadPDFMobile: "Generar QR",
    own_OrderSticker: "Pedir etiqueta QR",
    own_DeleteQuestion: "Eliminar la pregunta",
    own_DownloadAndPrint: "Descargar e imprimir",
    own_OrderStickerFrom: "Pida los QR smileys de AirVote",
    own_OrderStickerDescription: "Los QR smileys de AirVote se imprimen en vinilo resistente a la intemperie. Se entregan en 10-15 días. El estado del pedido se muestra en el panel de control",
    own_DeliveryAddress: "Introduzca la dirección de entrega",
    own_RecipientName: "Nombre del destinatario",
    own_RecipientPhone: "Teléfono del destinatario",
    own_RecipientEmail: "Email del destinatario",
    own_Comment: "Comentario",
    own_ShowZeroVotes: "Mostrar cero votos",
    own_PlaceOrder: "Hacer el pedido",
    own_CreateNew: "Crear una nueva pregunta de AirVote",
    own_EnterQuestion: "Introduzca su pregunta AirVote aquí",
    own_SpecifyLocation: "Especifique la ubicación",
    own_DownloadPDF_Title: "Pregunta añadida",
    own_DownloadPDF_Description: "Ahora puede descargar un PDF de la pregunta. Para pedir uno de AirVote® utilice el elemento \"Generar smileys QR\" en el menú de las preguntas",
    own_DownloadPDF_EditTitle: "Pregunta actualizada.",
    own_SureTODelete: "¿Borrar su pregunta?",
    own_DownloadSticker: "Descargar QR smileys PDF",
    own_StickerProportion: "Seleccione un diseño de smileys que se ajuste a sus necesidades",
    own_PanelTextLeaflet: "Compacto",
    own_PanelTextBusiness: "Tarjeta de visita",
    own_PanelTextExtended: "Estándar",
    own_PanelSubtitleLeaflet: "Imprima como una pequeña tarjeta de entrega al cliente o colóquela en el reverso de su tarjeta de visita",
    own_PanelSubtitleExtended: "Imprima en una pegatina o póster. Colóquelo al alcance del cliente",
    own_PanelSubtitleBusiness: "Un diseño más compacto para los casos en que necesite que los smileys QR de AirVote se impriman y distribuyan como tarjetas de visita",
    own_AllVotesWillDeleted: "Todos los votos para esta pregunta de AirVote® serán eliminados",
    own_HasBeenDeleted: "Pregunta eliminada",
    own_DontForgetCreate: "¡No olvides crear una nueva!",
    own_OrderHasBeenPlaced: "Su pedido ha sido realizado.",
    own_KeepTrack: "El estado del pedido se mostrará en el panel de control.",
    own_Manage: "Gestionar",
    own_Title: "Bienvenido al panel de empresas de AirVote",
    own_Business: "Su negocio",
    own_Subitle: "Indique el nombre de su empresa para poder crear preguntas. Esto se puede cambiar en cualquier momento más tarde",
    own_Address: "Dirección",
    own_BusinessName: "El nombre de su empresa",
    own_SaveBtn: "Guardar y continuar",
    own_SaveBtnWithQuestion: "Guardar y obtener mis smileys QR",
    own_CanNotFind: "No encuentro mi empresa",
    own_PleaseStartWriting: "Por favor, empiece a escribir el nombre de su negocio y elíjalo en el desplegable",
    own_filter_placeholder: "Empiece a escribir para filtrar",
    own_AssetId: "ID de activo",
    AnalyticSettings: "Opciones de análisis",
    AnalyticDescription: "Configurando esto se ajusta la forma en que se muestran los datos en el panel de análisis",
    AnalyticIndex: "Índice de análisis preferido",
    AnalyticWhatMean: "¿Qué significa esto?",
    AnalyticWhatMeanIndex: "¿Por qué el índice es una buena idea?",
    AnalyticWhatMeanIndexDescription: "El índice proporciona una medida objetiva para seguir las tendencias a lo largo del tiempo y comparar el rendimiento en diferentes áreas",
    AnalyticWhatMeanIndexValue: "",
    AnalyticIndexPromouterScore: "Puntuación del promotor neto: #\"votos felices\" * 100% + #\"más o menos\" votos * 0% - #\"tristes\" votos * 100%. La puntuación más alta es 100. La puntuación más baja es -100.",
    AnalyticIndexAirVoteScore: "Puntuación de AirVote: #\"votos felices\" * 100% + #\"más o menos\" votos * 50%. La puntuación más alta es 100. La puntuación más baja es 0.",
    ThereIsAnError: "Por favor, introduzca el valor correcto",
    StickerStatus: "Estado de la etiqueta",
    Requested: "Solicitado",
    Sent: "Enviado",
    Cancelled: "Cancelado",
    Close: "Cerrar",
    welcomeModalTitle: "Encuentre su empresa en el mapa",
    welcomeModalSubtitle: "Utilizamos los datos de Google para ayudarle a registrar su empresa en AirVote",
    welcomeModalSearchYouBusinass: "Busque su empresa utilizando la entrada en la parte superior de la pantalla",
    welcomeModalPickOnMap: "O selecciónela en el mapa",
    welcomeModalNotOnGoogle: "¿La empresa no está en Google? ¿Problemas? Escríbanos a",
    mapTipsSearch: "Busca tu empresa por su nombre",
    mapTipsPick: "O elíjalo en el mapa",
    OK: "OK",
    Location: "Colocación",
    Question: "Pregunta",
    companyManagement: "Gestión de la empresa",
    sites: "Sitios de negocios",
    site: "Sitio",
    SitesDescription: "Las sedes empresariales son diferentes sucursales o ubicaciones de su empresa. A cada sede se le puede asignar uno o varios gestores de sede para que coadministren el sistema AirVote de la misma",
    addNewSite: "Añadir sitio",
    siteDetail: "Detalles del sitio",
    questionsAndAnalytics: "Preguntas y análisis",
    companyInformation: "Información de la empresa",
    companyManagers: "Responsables de la empresa",
    saveChanges: "Guardar cambios",
    companyManagersDescription: "Puede asignar a otros gestores de la empresa para que coadministren el sistema AirVote de su empresa.",
    Invite: "Invitar a",
    EnterEmailToAssignCompanyManager: "Introduzca el correo electrónico para asignar un gestor de empresa",
    enterSeveralEmailByComma: "Puede introducir varios correos electrónicos separados por comas",
    Pending: "Pendiente",
    Accepted: "Aceptado",
    Remove: "Eliminar",
    ActiveManagers: "Gerentes activos",
    NoOthersCompanyManagersAssigned: "No hay otros gestores de empresa asignados",
    removeManager: "Quitar gerente: {v1}?",
    all: "Todos",
    editManagers: "Editar gerentes",
    assignManagers: "Asignar gestores",
    viewAnalytic: "Ver análisis",
    deleteSite: "Borrar sitio",
    deleteSiteConfirm: "Borrar sitio: {v1}?",
    siteManagers: "Administradores del sitio",
    SiteManagersNotAssigned: "No asignado",
    siteName: "Nombre del sitio",
    siteAddress: "Dirección del sitio",
    Website: "Sitio web",
    Email: "Email",
    Alias: "Alias",
    EditPhoto: "Editar foto",
    SitePhoto: "Foto del sitio",
    AirVoteSuggestsTitle: "AirVote sugiere",
    SearchForQuestion: "Preguntas sugeridas",
    UseQuestion: "Usar pregunta",
    ImagesSupportedParams: "Se admiten imágenes en formato PNG y JPG. El tamaño máximo de la foto es de 5 Mb",
    UploadFile: "Subir archivo",
    RemovePhoto: "Eliminar foto",
    ReturnBtn: "Volver",
    RemovePhotoConfirm: "¿Quitar la foto del sitio?",
    RemovePhotoSuccess: "Foto eliminada",
    WrongFormat: "Formato incorrecto. Por favor, utilice PNG o JPG",
    PhotoOverweight: "La foto es más de {v1}Mb",
    cancelInvite: "Cancela la invitación: {v1}?",
    createSiteMap: "Crear un nuevo sitio utilizando este lugar: {v1}?",
    chooseNewPlaceFrOrganization: "Por favor, elija un nuevo sitio para su organización.",
    MyBusinessIsMultipleSites: "Mi empresa tiene varios sitios",
    goingToMultipleSitesMode: "¿Solicita el modo de sitio múltiple para su organización?",
    by_questions: "Preguntas",
    by_sites: "Sitios",
    by_locations: "Lugares",
    groupBy: "Agrupar por",
    Diagram: "Diagrama",
    ID: "ID",
    Filter: "Filtrar",
    Comments: "Comentarios",
    ownLastVotes: "Últimos votos",
    IndexAirvote: "Índice AirVote",
    TotalVotes: "Total de votos",
    Notifications: "Alertas",
    CloseAccount: "Cerrar mi cuenta",
    DowngradeToClient: "Bajarme a cliente",
    sendAlertEvery: "Enviar notificación cada",
    SendNotificationEach2: "voto(s)",
    IncludeSosoVotes: "Incluir los votos mediocres",
    SMS: "SMS",
    Reports: "Informes",
    daily: "Diario",
    weekly: "Semanalmente",
    monthly: "Mensualmente",
    SendRequestToClose: "Cerrar su cuenta?",
    SendRequestToRestore: "Enviar solicitud para restaurar la cuenta?",
    RestoreAccount: "Restaurar cuenta",
    DowngradeProfileToClient: "¿Descender el perfil al rol de cliente?",
    ProfileSettings: "Configuración del perfil",
    savedSuccessfuly: "La configuración se ha guardado correctamente",
    Message: "Mensaje",
    NoData: "No hay datos",
    Decline: "Declinar",
    Approve: "Aprobar",
    DeclineRequest: "¿Rechazar la solicitud de eliminar la cuenta?",
    ApproveRequest: "¿Aprobar la solicitud de eliminación de la cuenta?",
    MyPlaces: "Mis sitios",
    EmptySiteTitle: "Tu empresa no tiene ningún sitio configurado. Añada uno.",
    EmptySiteDescription: "Los sitios son diferentes sucursales u oficinas de su empresa. A cada sitio se le puede asignar uno o más administradores de sitio. Un administrador de sitio puede editar los detalles del sitio y tener acceso a los análisis del sitio",
    accountSettings: "Configuración de la cuenta",
    accountSettingsDescription: "Modificar los datos de su perfil, gestionar las notificaciones y los informes que recibe",
    otherOptions: "Otras opciones",
    UploadNewPhoto: "Subir una nueva foto",
    receiveBadVotesViaSms: "Puedes recibir notificaciones sobre los votos Triste o So-so por correo electrónico o SMS",
    Threshold: "Umbral",
    SoSoVotes: "Votos más o menos buenos",
    Channel: "Canal",
    DisableAllNotifications: "Desactivar todas las notificaciones",
    EnableAllNotifications: "Activar todas las notificaciones",
    sendDetailedReportToEmail: "Podemos enviar informes detallados a su correo electrónico",
    Regularity: "Regularidad",
    nothingSelected: "Nada seleccionado",
    allNotificationsDisabled: "Todas las notificaciones deshabilitadas",
    createNewUser: "Crear un nuevo usuario",
    exportRawData: "Exportar datos en bruto",
    exportTo: "Exportar a",
    tab_Map: "Mapa",
    smileysMailTitle: "¡Tus smileys QR de AirVote están en camino!",
    smileysMailSubtitle: "Compruebe {v1} para sus smileys QR. Si no los recibes en unos minutos, comprueba tu carpeta de Spam o",
    smileysMailDownload: "descargue aquí",
    smileysMailChecklist: "Ahora puedes entrar en tu panel de empresa. Utilícelo para:",
    smileysMailChecklistFirst: "Consultar los informes de votación de los clientes en tiempo real",
    smileysMailChecklistSecond: "Crear e imprimir preguntas adicionales",
    smileysMailChecklistThird: "Configurar alertas en tiempo real sobre áreas problemáticas",
    smileysMailChecklistFourth: "Ver los análisis avanzados",
    smileysMailChecklistMore: "...¡y mucho más!",
    smileysMailChecklistBtn: "Llévame a mi panel de negocios ahora",
    smileysMailChecklistBack: "Volver a la página web",
    signIn_enter: "Entra, usando",
    signIn_or: "o",
    signIn_difficulties: "¿Tiene dificultades?",
    signIn_contact: "Contacte con nosotros en",
    question_suggestions_freq_title: "Usado recientemente",
    signIn_signIn_title: "Iniciar sesión",
    signIn_signUp_title: "Regístrese",
    signIn_enter_using_email: "o entra con tu correo electrónico",
    signIn_email_hint: "Dirección de correo electrónico",
    signIn_password_hint: "Contraseña",
    signIn_signInBtn: "Iniciar sesión",
    signIn_forgotPass_btn: "¿Ha olvidado su contraseña?",
    signIn_noCreditReq: "No se requiere tarjeta de crédito",
    signIn_firstName_hint: "Nombre de pila",
    signIn_lastName_hint: "Apellido",
    signIn_signUp_btn: "Regístrese",
    signIn_useMedia: "O regístrese utilizando las redes sociales",
    signIn_agreeTo: "Estoy de acuerdo con AirVote",
    signIn_tAndC: "Términos y Condiciones",
    signIn_recoverPassword: "Recupere su contraseña",
    signIn_recoverPassSubtitle: "Introduzca el correo electrónico utilizado para acceder a su cuenta",
    signIn_recoverPassContinue: "Continuar",
    signIn_recoverPassBack: "Volver a Iniciar sesión",
    signIn_protected: "Este sitio está protegido por reCAPTCHA y por la política de privacidad de Google",
    signIn_privacyPolice: "Política de privacidad",
    signIn_and: "Y",
    signIn_Terms: "Condiciones de servicio",
    signIn_Login: "Iniciar sesión con {v1}",
    signIn_Register: "Regístrese con {v1}",
    signIn_RegisterWithEmail: "Registrarse con la dirección de correo electrónico",
    signIn_RegisterWithQuestion: "Siguiente: Acerca de mi negocio",
    signIn_SeparatorText: "O",
    signIn_TitleWithQuestion: "Regístrese en AirVote para:",
    signIn_ChecklistFirst: "Recibir sus QR smileys por correo electrónico",
    signIn_ChecklistSecond: "Acceder al panel de tu negocio para hacer un seguimiento de las respuestas (votos)",
    auth_confirm_email_confirming: "Confirmar tu correo electrónico 🔄",
    auth_confirm_email_confirmed: "Email confirmado con éxito ✅\nRedirigiendo al panel de empresa...",
    auth_confirm_email_already_confirm: "Su correo electrónico ya fue confirmado",
    login_btn_link: "Inicie sesión en",
    login_btn_text: "a su panel de negocios",
    password_validation_min_length: "Mínimo 6 caracteres de longitud",
    password_validation_uppercase: "Una letra mayúscula",
    password_validation_lowercase: "Una letra minúscula",
    loadPdfProgress: "Por favor, espera hasta que tu PDF se esté generando 🔄.",
    showManagePopupTitle: "Gestionar las preguntas, descargar los smileys QR",
    showManagePopupSubtitle: "¡Bienvenido al panel de negocios de AirVote! Cada bloque que ves en la pantalla es una pregunta que has configurado. Utiliza el icono para gestionar las preguntas: editar, eliminar o descargar los emoticonos QR como PDF",
    showFeedbackPopupTitle: "Empieza a recibir comentarios",
    showFeedbackPopupSubtitle: "Cuando tengas tus smileys QR impresos, colócalos en un lugar que sea visto por el cliente. Cada voto se muestra inmediatamente en el panel de su negocio",
    showAlertsPopupTitle: "Configura y recibe alertas",
    showAlertsPopupSubtitle: "¡Enhorabuena por haber conseguido tus primeros votos! ¿Sabes que puedes recibir notificaciones sobre cualquier voto en tu móvil o correo electrónico? Utiliza tu página de perfil para configurar las reglas de notificación",
    driverMainText: "Sólo tienes acceso a través de la pantalla de votaciones. Por favor, escanea la pegatina",
    helpCenterTitle: "Centro de ayuda",
    orderBannerSubtitle: "Podemos imprimir sus preguntas en un vinilo impermeable y enviarlo a cualquier parte del mundo",
    orderBannerBtn: "Pedir pegatinas",
    orderStickersBtn: "Pedir pegatinas QR",
    orderPageBtn: "Comencemos",
    orderSelectTitle: "Seleccione las preguntas que desea imprimir",
    orderBusinessSite: "Sitio de la empresa",
    orderBusinessPlacement: "Colocación",
    orderTotal: "Total del pedido",
    orderDelivery: "Entrega",
    orderDeliveryText: "Gratis",
    orderFormTitle: "Complete su pedido",
    orderFormSubtitle: "El plazo de entrega aproximado es de 10-15 días",
    orderShippingTitle: "Envío fuera de Estados Unidos o Europa",
    orderShippingSubtitle: "Póngase en contacto con AirVote para obtener el presupuesto del pedido, incluyendo todos los gastos de envío y de aduana",
    orderQuote: "Obtenga un presupuesto",
    orderSuccessPayment: "Su pedido ha sido creado con éxito. Nos pondremos en contacto con usted en breve y le proporcionaremos un presupuesto",
    orderSuccessPayPal: "Su pedido ha sido pagado correctamente. Se le notificará cuando se envíe el pedido",
    orderCountryLabel: "País",
    orderStickerSizeLabel: "Tamaño del adhesivo",
    orderBtnToDashboard: "Ir al panel de control",
    unsubscribeBtn: "Anular la suscripción",
    unsubscribeSaveBtn: "Actualizar la configuración",
    unsubscribePopupText: "Desinscribirse ahora",
    orderShippingBlockTitle: "Información de entrega",
    title_404: "La página a la que intenta acceder no está disponible",
    btn_404: "Volver a la página anterior",
    dataReportPopup: "No hay datos. Por favor, cambie sus filtros o elija un rango de fechas diferente",
    dataReportPopupMobileXLSX: "Este archivo sólo contiene los datos de los votos. Para los análisis y gráficos detallados de los votos, utilice el panel de control de AirVote en PC o Mac",
    manageScreenQuestion: "Pregunta",
    manageScreenLocation: "Descripción de la ubicación",
    manageSetGeolocation: "Establecer geolocalización",
    manageSetAsset: "Activo",
    manageGeolocation: "Geolocalización",
    manageUpdateBtn: "Actualizar",
    manageLatitude: "Latitud",
    manageLongitude: "Longitud",
    manageGPSAccuracy: "Precisión GPS {v1}m",
    manageGPSLocation: "Localización GPS",
    manageGPSAllowText: "Por favor, permita que air-vote.com obtenga los datos de localización GPS de su teléfono",
    manageGPSAllowSubtitle: "* lo utilizaremos sólo cuando visite esta página para actualizar la geolocalización de la pregunta",
    manageGPSPopupLongDistance: "Sus coordenadas GPS actuales están muy lejos de la colocación anterior de la pegatina {v1}m",
    manageGPSPopupBadAccuracyAndLongDistance: "Sus coordenadas GPS actuales están muy lejos de la colocación anterior de la pegatina {v1}m y tienen poca precisión {v2}m",
    manageGPSPopupBadAccuracy: "Sus coordenadas GPS actuales tienen poca precisión ({v1}m)",
    manageGPSPopupSureNewCoords: "¿Está seguro de utilizar las nuevas coordenadas?",
    manageGPSPopupUseNewCoordsBtn: "Utilice las nuevas coordenadas",
    manageGPSPopupChangeManuallyBtn: "Cambiar manualmente",
    manageMapBtn: "Utilice esta ubicación",
    manageSaved: "Guardado",
    manageCopiedToClipboard: "Copiado en el portapapeles",
    manageGPSUnableToFetchMsg: "No hemos podido obtener la ubicación del GPS. Por favor, inténtelo de nuevo",
    manageGPSUnavailable: "La ubicación GPS no está disponible. Vuelve a intentarlo o ponte en contacto con nuestro equipo de asistencia",
    manage_back_to_yard: "Back to yard",
    w3wTitle: "Una forma sencilla de describir la ubicación en cualquier parte del mundo",
    w3wLearnMore: "Más información",
    unassignedQuestion: "Las preguntas no asignadas",
    own_votesNotFound: "Parece que no tienes ningún voto reciente 😔\n\nPor favor, asegúrate de que tus AirVote Stickers siguen en su sitio y funcionan correctamente",
    own_votesQuestion: "Pregunta:",
    own_votesPlacement: "Colocación:",
    own_votesPriorVotes: "Votaciones previas del usuario:",
    own_votesUser: "Usuario:",
    own_votesComment: "Comentario:",
    own_votesContactInfo: 'Información de contacto:',
    bulkPlacement: "Edición de colocación masiva",
    bulkPlacementPopupSavedQuestions: "Preguntas seleccionadas",
    bulkPlacementPopupSelectAll: "Seleccionar todo",
    bulkSuccessfulPlaceEdit: "La colocación fue cambiada con éxito",
    showAllVotes: "Mostrar todos los votos recientes",
    bulkInputPlaceHolder: "Nueva colocación",
    copy: "Copiar",
    telegramPopupGroup: "Añadir Bot al grupo",
    telegramPopupPrivate: "Añadir Bot al chat privado",
    telegramPopupTitle: "Tu Hash",
    setupTelegramBtn: "Configurar el bot de Telegram",
    telegramHashAvailable: "El hash actual está disponible durante 1 hora",
    moreOptiosPopuoTitle: "Mas opciones",
    emailSignature: 'Comunicaciones electronicas',
    emailSignatureSubtitle: "Copie / pegue los emoticonos en sus correos electrónicos, facturas electrónicas o para cualquier presentación en línea",
    emailSignatureTitle: '¿Cómo le está funcionando AirVote hasta ahora?',
    emailSignatureClick: 'Haga clic en un smiley para dejar su opinión',
    emailSignatureCopyLink: 'Copiar link',
    singleEmailSignaturePageTitle: 'Agregue AirVote E-Smiley a sus comunicaciones',
    copied: 'Copiado',
    airLeads: 'AirLeads',
    serviceLogs: 'Service logs',
    serviceLog: 'Registro di servizio',
    airLeadSubmittedBy: 'Presentado por:',
    airLeadChooseDriver: 'elegir conductor',
    airLeadCompanyName: 'Nombre de empresa',
    airLeadSiteType: 'Tipo de sitio',
    airLeadOpportunity: 'Oportunidad',
    airLeadCustomer: 'Cliente',
    airLeadAdditionalNotes: 'Notas adicionales',
    airLeadMoreService: 'Más servicio',
    airLeadMoreUnits: 'Más unidades',
    airLeadSink: 'Un fregadero',
    airLeadCallThem: 'Para llamarlos',
    airLeadSubmitALead: 'Envíe un cliente potencial',
    airLeadHideLeads: 'Ocultar prospectos cerrados',
    airLeadShowAllLeads: 'Mostrar todos los clientes potenciales',
    airLeadDashboardDate: 'Fecha',
    airLeadDashboardType: 'Escribe',
    airLeadDashboardStatus: 'Estado',
    airLeadDashboardStatusNotes: 'Notas de estado',
    airLeadDashboardLastActionDate: 'Fecha de última acción',
    airLeadDashboardActionBy: 'Acción por',
    airLeadDashboardSalesFollowUp: 'Sales followup',
    airLeadDashboardNotClosed: 'No cerrado',
    airLeadDashboardClosedWon: 'Cerrado/Ganado',
    airLeadDashboardNotQualified: 'No calificado',
    airLeadDashboardCommission: 'Comisión',
    airLeadDashboardNotLeadsFound: 'No se encontraron clientes potenciales',
    airLeadDashboardRefresh: 'Actualizar',
    airLeadInfoPopupDriver: 'Conductor',
    airLeadInfoPopupNotes: 'Notas',
    airLeadInfoPopupLocation: 'Ubicación',
    airLeadInfoPopupViewOnMap: 'Ver en el mapa',
    airLeadInfoPopupServices: 'Servicios',
    airLeadStatusAndCommissionError: 'Ingrese notas de estado y comisión para cerrar un cliente potencial',
    airLeadStatusNotesError: 'Ingrese las notas de estado para cerrar un cliente potencial',
    airLeadNewCustomerLead: 'Nuevo cliente potencial',
    airLeadExistingCustomer: 'Cliente potencial existente',
    airLeadPleaseChooseDriver: 'Por favor elija un conductor',
    airLeadPleaseCompanyInfo: 'Ingrese la información de la empresa',
    airLeadPleaseCustomerInfo: 'Por favor ingrese la información del cliente',
    airLeadGoodLack: '¡Buena suerte con tu liderazgo! \n¡Gracias por ayudarnos a atraer nuevos clientes!',
    airLeadCommission: 'La comisión debería ser mayor que 0',
    airLeadNumberShouldContains: 'El número debe contener menos de 3 dígitos',
    sldPlaceGuid: 'Guía del lugar',
    sldOrganizationGuid: 'guía de la organización',
    sldGetPlaceConfig: 'Recargar la configuración',
    sldEnableDetails: 'Habilitar detalles de nivel 2d',
    sldBasicConfig: 'Configuración básica',
    sldScreenTitle: 'título de la pantalla',
    sldScreenSubTitle: 'Subtítulo',
    sldScreenBackground: 'fondo de pantalla:',
    sldMaxCount: 'Recuento máximo de elementos seleccionados',
    sldEnterForUnlimited: 'Ingrese 0 para ilimitado',
    sldShowComment: 'Mostrar comentario siempre',
    sldBlocks: 'bloques:',
    sldText: 'Texto',
    sldGreenScreen: 'Pantalla verde',
    sldYellowScreen: 'pantalla amarilla',
    sldRedScreen: 'pantalla roja',
    sldOverrideSettings: 'Anular la configuración básica',
    sldOverrideBlocks: 'Anular bloques básicos',
    sldSecondLevelDetails: 'Detalles del Segundo Nivel',
    configMissingMsg: 'Falta la configuración, ¿quieres habilitarla?',
    sldTakeFromPlace: 'Tomar del lugar',
    sldChooseAnIcon: 'Elija un icono',
    sldEditIcon: 'Editar icono',
    sldUploadIcon: 'Cargar un nuevo icono',
    sldIconTag: 'Etiqueta Icono',
    sldPleaseFillInput: 'Por favor, complete el campo',
    sldDefaultText: 'Texto por defecto',
    sldChooseIcon: 'Por favor, elija el icono',
    sldSaveAndAddMore: 'Guardar y añadir más',
    sldAddIcon: 'Añadir icono',
    sldAreYouSure: "¿Vas a borrar esta imagen?",
    enableServiceLog: 'Activar la configuración del registro de servicios',
    serviceLogRequirePin: 'Requerir pasador',
    serviceLogInfoPopup: 'Mostrar la ventana emergente de información del registro de servicio',
    serviceLogPlacementEdit : 'Edición de la ubicación del espectáculo',
    commentViewOnMap: 'Ver en el mapa',
    sldTagInUseErrorTitle: "No se puede realizar esta acción. La etiqueta está actualmente en uso:",
    tab_AssetsMap: "Mapa de aseos",
    settings_checkbox_GoogleReviewAlerts: "Google review alerts"
}
